import { LifeCycles, registerApplication, start, unregisterApplication } from 'single-spa';

import { Logger } from 'services/logger';

export enum MfeNames {
  ECONOMIC_CALENDAR = '@ig-exp/ig-econ-calendar-fe',
}

export class SingleSpaService {
  constructor(
    private appName: string,
    private rootElement: HTMLDivElement | null
  ) {}

  private getMfeProps() {
    switch (this.appName) {
      case MfeNames.ECONOMIC_CALENDAR: {
        return {
          domElement: this.rootElement,
          env: 'prod',
          econPreferences: {
            preferences: {
              currentLocale: 'en_US',
              igCompany: 'igus',
              isWebsite: true,
            },
          },
        };
      }
    }
  }

  private async loadMfe() {
    const module: LifeCycles = await window.System.import(this.appName);

    registerApplication({
      name: this.appName,
      app: module,
      activeWhen: () => true,
      customProps: this.getMfeProps(),
    });

    start();
  }

  public async mount() {
    try {
      if (!this.appName) {
        return;
      }

      await this.loadMfe();
    } catch (err) {
      Logger.error('Error during single-spa mount: ', err);
    }
  }

  public unmount() {
    try {
      if (!this.appName) {
        return;
      }

      window.System.delete(this.appName);
      unregisterApplication(this.appName);
    } catch (err) {
      Logger.error('Error during single-spa unmount: ', err);
    }
  }
}
